export default {
  meta: {
    title: '分享已失效',
  }
};
